import { AssessmentNodes } from "@p0security/shared/types/assessment/data/index";
import { Typography } from "antd";
import moment from "moment";

const { Text } = Typography;

export const LastRotated: React.FC<{
  credential: AssessmentNodes["credential"];
}> = ({ credential: { type, createdTime } }) => (
  <>
    {createdTime ? (
      moment(createdTime).format("LL")
    ) : type === "short-lived" ? (
      <Text type="secondary">N/A</Text>
    ) : (
      <Text type="secondary">(Unknown)</Text>
    )}
  </>
);
